<template>
  <v-app>
    <v-main class="main">

      <!-- Sidebar -->
      <Sidebar :drawerOpen="drawerOpen" :collapsed="isSidebarCollapsed" :isMobile="isMobile"
        @update:drawerOpen="drawerOpen = $event" />

      <v-container fluid class="main-content pa-4">

        <!-- Header -->
        <Header :isDarkMode="isDarkMode" :isMobile="isMobile" @toggle-sidebar="toggleSidebar" />

        <div class="content">

          <v-row class="g-4 mt-4 mb-8" dense>

            <v-col cols="12" sm="12">
              <div class="column-title mb-6">
                <h5 class="m-0 text-left">Investment Opportunities</h5>
                <hr class="title-separator" />
              </div>
            </v-col>

            <GlobalKyc />
            <template v-if="loading">

              <v-col cols="12" v-for="n in 4" :key="n">
                <v-card class="pa-6" rounded="lg">
                  <v-skeleton-loader type="heading" class="mb-4" />
                  <v-skeleton-loader type="text" />
                  <v-skeleton-loader type="text" width="80%" class="mt-2" />
                </v-card>
              </v-col>

            </template>
            <!-- Investment type Cards -->
            <template v-else>
              <v-col v-for="(inv, index) in investmentsList" :key="index" cols="12" md="4" class="pa-2">
                <v-card class="product-card pa-6 h-100" flat>

                  <!-- TOP: Logo + Name -->
                  <div class="d-flex align-center gap-2 mb-4">
                    <!-- <img :src="inv.product_type_image ? `${STORAGE_URL}/${inv.product_type_image}` : defaultImage"
                    class="product-image" /> -->
                    <img :src="getImage(inv.product_type_image)" @error="handleImageError" class="product-image" />
                    <div class="text-left">
                      <div class="font-weight-bold text-body-1">
                        {{ inv.name }}
                      </div>
                      <div class="text-caption">
                        <span :class="getRiskClass(inv.risk_category.name)">
                          {{ inv.risk_category.name }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- INNER CARD -->
                  <v-card class="inner-mini-card pa-4 mb-3" flat>
                    <div class="d-flex justify-space-between">

                      <!-- LEFT: Maturity -->
                      <div class="text-left text-grey">
                        <div class="font-weight-medium small-text">
                          {{ inv.description }}
                        </div>
                      </div>

                      <!-- RIGHT: Rate -->
                      <!-- <div class="text-right">
                      <div class="text-caption text-grey">Rate</div>
                      <div class="font-weight-medium text-green">
                        {{ formatNumber(product.interest) }}%
                      </div>
                    </div> -->

                    </div>
                  </v-card>

                  <!-- BOTTOM ROW -->
                  <div class="d-flex justify-space-between align-center mt-auto">

                    <!-- Risk -->
                    <div class="text-caption">
                      <span class="text-caption font-weight-medium clickable-title" @click="viewProduct(inv.uuid)">
                        See what’s available
                      </span>
                      <v-icon size="16" class="ms-1">mdi-arrow-right-circle</v-icon>
                    </div>

                    <!-- View Details -->
                    <!-- <div class="d-flex align-center gap-2">
                    <span class="text-caption font-weight-medium">
                      View Details
                    </span>
                    <v-icon size="16">mdi-arrow-right-circle</v-icon>
                  </div> -->

                  </div>

                </v-card>
              </v-col>
            </template>
          </v-row>
        </div>



      </v-container>
    </v-main>
  </v-app>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from "vue"
import Sidebar from "@/components/Sidebar.vue"
import Header from "@/components/Header.vue"
import { useRouter } from "vue-router"
import { useInvStore } from "@/store/investment"
import { STORAGE_URL } from "@/api/env"
import { getRiskClass } from "@/util"

//avatar
import avatarImage from '@/assets/crowdital-icon.png'
import GlobalKyc from "@/components/GlobalKyc.vue"


const router = useRouter()
const inv = useInvStore();
// const auth = useAuthStore()

const isSidebarCollapsed = ref(false)
const drawerOpen = ref(false)
const isMobile = ref(false)
const loading = ref(true)
//const filters = ref({ global: { value: null, matchMode: "contains" } })

//Product type image
const defaultImage = avatarImage

const getImage = (image) => {
  return image ? `${STORAGE_URL}/${image}` : defaultImage
}

const handleImageError = (event) => {
  event.target.src = defaultImage
}

/* Mobile */
const toggleSidebar = () => {
  if (isMobile.value) drawerOpen.value = !drawerOpen.value
  else isSidebarCollapsed.value = !isSidebarCollapsed.value
}

const checkMobile = () => {
  isMobile.value = window.innerWidth < 768
  drawerOpen.value = !isMobile.value
}

/* Lifecycle */
onMounted(async () => {
  checkMobile()
  window.addEventListener("resize", checkMobile)
  await inv.loadInvestmentType()
  loading.value = false
})

onUnmounted(() => {
  window.removeEventListener("resize", checkMobile)
})

/* Products */
const investmentsList = computed(() => inv.investments || [])

//View link on the card
const viewProduct = (id) => {
  router.push(`/products/${id}`)
}
</script>

<style scoped>
.main {
  display: flex;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  background-color: #f8fafc;
  padding-left: 5%;
  padding-right: 5%;
}

.content {
  padding-left: 10%;
  padding-right: 10%;
}

/* Card */
.table-card {
  padding: 20px;
  border-radius: 14px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
}

/* Header */
.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* Table */
.modern-table {
  border: none;
}

/* Product */
.product-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.product-image {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  object-fit: cover;
  margin-right: 2%;
}

.product-name {
  font-weight: 700;
}

.product-desc {
  font-size: 16px;
  color: #64748b;
}


/* Search input */
.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 8px;
  color: #64748b;
}

.search-wrapper input {
  padding-left: 28px;
}

/* Button */
.theme-button {
  height: 46px;
  background: #000;
  color: #fff;
  border-radius: 10px;
  font-weight: 600;
  transition: all 0.25s ease;
}

/* Column title */
.column-title h5 {
  font-size: 1.1rem;
  font-weight: 400;
  margin-bottom: 2.5%;
}

/* Horizontal line below title */
.title-separator {
  border: none;
  height: 1px;
  background-color: #eae5e5;
  margin: 0;
  margin-bottom: 8px;
}

.inner-transaction-card>div:hover {
  background: #f9f9f9;
  border-radius: 6px;
}

.product-card {
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

.inner-mini-card {
  border: 1px solid #eae5e5;
  border-radius: 8px;
  background: #fff;
}

.small-text {
  font-size: 0.9rem;
  line-height: 1.2;
}

.clickable-title {
  cursor: pointer;
  transition: 0.2s ease;
}

.clickable-title:hover {
  opacity: 0.7;
}

.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* Mobile */
@media (max-width: 600px) {
  .content {
    padding: 0;
  }

  .avatar-mobile {
    width: 32px;
    height: 32px;
  }

  .title-mobile {
    font-size: 0.9rem;
  }

  .icon-mobile {
    font-size: 16px;
  }
}
</style>
